/**
 * 🔒 Secure Logger Utility
 * 
 * Only logs in development mode when NODE_ENV is explicitly set to 'development'
 * All other cases (production, test, undefined, etc.) will not log anything
 * 
 * This prevents sensitive data from being logged in production environments
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const secureLog = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  error: (...args: any[]) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  }
};

// Export individual functions for convenience
export const { log, warn, error, info, debug } = secureLog;